import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IonButton, IonIcon, IonSpinner } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { informationCircleOutline, pencilOutline } from 'ionicons/icons';
import { Observable } from 'rxjs';
import { ParentHubStripe } from 'src/plugins/parent-hub-stripe';
import { SlipComponentInfo } from '../../student-slip-item-choices-modal/student-slip-item-choices-modal.store';
import { ItemChoicesComponentInfo, PaymentStatus } from '../../student-slip-modal.store';
import { FormState, StudentSlipItemChoicesPaymentHybridStore } from './student-slip-item-choices-payment-hybrid.store';

@Component({
  selector: 'app-student-slip-item-choices-payment-hybrid',
  templateUrl: './student-slip-item-choices-payment-hybrid.component.html',
  styleUrls: ['./student-slip-item-choices-payment-hybrid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [StudentSlipItemChoicesPaymentHybridStore],
  imports: [IonButton, IonIcon, IonSpinner, CommonModule]
})
export class StudentSlipItemChoicesPaymentHybridComponent implements OnInit, OnDestroy {
  @Input() set slipComponentInfo(value: SlipComponentInfo) {
    this.store.patchState({ slipComponentInfo: value });
  }
  @Input() set itemChoicesComponentInfo(value: ItemChoicesComponentInfo) {
    this.store.setItemChoicesComponentInfo(value);
  }
  @Input() paymentStatus: PaymentStatus;
  @Input() reservationExpiresOn: string;

  @Output() paymentMethodUpdated = new EventEmitter<string>();
  @Output() readonly paymentStatusChange = this.store.paymentStatus$;
  @Output() requestReservationRefresh = new EventEmitter<void>();

  readonly vm$: Observable<FormState> = this.store.vm$;

  constructor(private store: StudentSlipItemChoicesPaymentHybridStore) {
    addIcons({ pencilOutline, informationCircleOutline });
  }
  ngOnDestroy(): void {
    ParentHubStripe.removeAllListeners();
  }

  ngOnInit(): void {
    this.store.patchState({
      paymentStatus: this.paymentStatus,
      reservationExpiresOn: this.reservationExpiresOn,
      refreshReservationEmitter: this.requestReservationRefresh
      // payNowAmount: this.paymentInfo?.balance
    });
    this.store.initialiseStripe();

    ParentHubStripe.addListener('paymentMethodChanged', (innerResult: any): void => {
      this.store.patchState({
        paymentMethod: {
          methodId: innerResult.paymentMethodId,
          cardBrand: innerResult.cardBrand,
          cardLast4: innerResult.cardLast4
        },
        progressError: null
      });
      this.paymentMethodUpdated.emit(innerResult.paymentMethodId);
    });
    ParentHubStripe.addListener('applePayIntentRequired', (): void => {
      this.store.loadApplePayIntent();
    });
  }

  onEditAmount(): void {
    this.store.editAmount();
  }

  onChooseMethod(): void {
    this.store.chooseMethod();
  }
  onConfirm(): void {
    this.store.payNow();
  }
  onPayWithGooglePay(): void {
    this.store.payWithGooglePay();
  }
  onPayWithApplePay(): void {
    this.store.payWithApplePay();
  }
}
